
import TitleService from 'title-service';
import './EpisodeItem.scss';

export interface EpisodeItemArgs {
    title: string;
    time: number;
    description: string;
    thumbnailUrl: string;
    number: number;
    onPlay: () => void;
}

export default function EpisodeItem(props: EpisodeItemArgs) {

    return (
        <div className="titleCardList--container episode-item " tabIndex={0}
            onClick={() => {
                if (props.onPlay) {
                    props.onPlay();
                }
            }}
            aria-label={props.title} data-uia="titleCard--container" role="button">
            <div className="titleCard-title_index">{props.number}</div>
            <div className="titleCard-imageWrapper">
                <div className="ptrack-content" >
                    <img src={props.thumbnailUrl || "https://occ-0-92-90.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABZP8z7TqCJGpg80QK7eScMZbM1swxoJ8EnPRyfhIsNGYOBu6g243Hy-K5sMEpMvhNxsbjI_87OgnYP4mN8_9dD8DhI9TU7vFswvClLBF0IfckJkV.jpg?r=2c9"}
                        alt={props.title} />
                </div>
                <div className="titleCard-playIcon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="titleCard-playSVG">
                        <path d="M4 2.69127C4 1.93067 4.81547 1.44851 5.48192 1.81506L22.4069 11.1238C23.0977 11.5037 23.0977 12.4963 22.4069 12.8762L5.48192 22.1849C4.81546 22.5515 4 22.0693 4 21.3087V2.69127Z" fill="currentColor">
                        </path>
                    </svg>
                </div>
                <progress style={{ visibility: 'hidden' }} className="titleCard-progress" max="1" value="1">
                </progress>
            </div>
            <div className="titleCardList--metadataWrapper">
                <div className="titleCardList-title">
                    <span className="titleCard-title_text">{props.title}</span>
                    <span>
                        {typeof (props.time) === 'number' && <span className="duration ellipsized">{Math.ceil(props.time / 60)} &nbsp;{TitleService('min')}</span>}
                    </span>
                </div>
                <p className="titleCard-synopsis previewModal--small-text">
                    <div className="ptrack-content" >{props.description}</div>
                </p>
            </div>
        </div>
    );
}